import React from "react"

//Components
import Layout from "../container/Layout"
import Main from "../modules/main"

const IndexPage = () => (
  <Layout
    title={"Промо акції від ТАСКОМБАНК 🤑"}
    description={
      "Будь в курсі всіх промо акцій від ТАСКОМБАНК, бери участь і вигравай незабутні подарунки"
    }
    link={`https://tascombank.ua/promo/`}
  >
    <Main></Main>
  </Layout>
)

export default IndexPage
